module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "layout-list"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "small-3 columns small-centered"
  }, [_c('error-reveal', {
    attrs: {
      "error": _vm.error
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "small-3 columns small-centered"
  }, [_c('flash-reveal', {
    attrs: {
      "msg": _vm.flashMsg
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row small-collapse"
  }, [_c('div', {
    staticClass: "small-12 columns"
  }, [_c('data-grid', {
    attrs: {
      "items": _vm.items,
      "columns": _vm.columns
    },
    on: {
      "additem": _vm.onAddNewItem,
      "itemaction": _vm.onItemAction,
      "refresh": _vm.onGridRefresh
    }
  })], 1)]), _vm._v(" "), _c('data-store', {
    ref: "store",
    attrs: {
      "service": _vm.service,
      "filter": _vm.filter,
      "sort": _vm.sort
    },
    on: {
      "beforeload": _vm.onBeforeLoad,
      "afterload": _vm.onAfterLoad,
      "dataloaded": _vm.onDataLoaded,
      "loaderror": _vm.onLoadError
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c8c9ddd4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/analytics/List.vue
// module id = 491
// module chunks = 2